import { FC } from "react";
import { PlayerBowlStats } from "../../schema/schema";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import sortBy from "lodash.sortby";

interface StatsTableProps {
	stats: PlayerBowlStats[];
}

type RowData = {
	Name: string;
	Matches: number;
	Overs: number;
	Runs: number;
	Wkts: number;
	Maidens: number;
	Average: number | "-";
	Best: string;
	NoBalls: number;
	Wides: number;
	"5WIs": number;
	"10WMs": number;
};

const BowlStatsTable: FC<StatsTableProps> = ({ stats }) => {
	const sortedStats = sortBy(stats, "Name").filter(stat => !stat.Name.includes("***"));

	const rows: RowData[] = sortedStats.map(({ Name, Statistics }) => {
		let avg: number | "-" = 0;
		avg = Math.round((Statistics.BowlingRuns / Statistics.BowlingWickets) * 100) / 100;

		if (Statistics.BowlingWickets === 0) {
			avg = 0;
		}

		if (Statistics.BowlingRuns === 0) {
			avg = "-";
		}

		const overs = Math.floor(Statistics.BowlingBalls / 6) + "." + (Statistics.BowlingBalls % 6);

		return {
			Name: Name,
			Matches: Statistics.Matches,
			Overs: parseFloat(overs),
			Runs: Statistics.BowlingRuns,
			Wkts: Statistics.BowlingWickets,
			Maidens: Statistics.BowlingMaidens,
			NoBalls: Statistics.BowlingNoBalls,
			Average: avg,
			Wides: Statistics.BowlingWides,
			Best: Statistics.BowlingBestInnings,
			"5WIs": Statistics.Bowling5WIs,
			"10WMs": Statistics.Bowling10WMs
		};
	});

	const columns = [
		{ field: "Name" as keyof RowData, filter: true, maxWidth: 200 },
		{ field: "Matches" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Overs" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Runs" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Wkts" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Maidens" as keyof RowData, maxWidth: 120 },
		{ field: "Average" as keyof RowData, maxWidth: 120 },
		{ field: "Best" as keyof RowData, maxWidth: 80 },
		{ field: "NoBalls" as keyof RowData, maxWidth: 100 },
		{ field: "Wides" as keyof RowData, maxWidth: 100 },
		{ field: "5WIs" as keyof RowData, maxWidth: 80 },
		{ field: "10WMs" as keyof RowData, maxWidth: 120 }
	];

	return (
		<div className="w-full overflow-x-auto">
			<div className="ag-theme-quartz min-w-[920px]" style={{ height: 720 }}>
				<AgGridReact columnMenu="new" rowData={rows} columnDefs={columns} />
			</div>
		</div>
	);
};

export default BowlStatsTable;
